import { Account } from '@/domain/usecases'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import BaseLoader, { RecordsDefer } from './base-loader'

export default abstract class CompanyManagerBaseLoader extends BaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly redirectUrl: string | undefined,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined,
    readonly requiredFeatureFlag?: FeatureFlag.Key
  ) {
    super(account, redirectUrl, queryClient)
  }

  async defer(deferRecords: RecordsDefer) {
    const allowed = !this.requiredFeatureFlag || this.requiredFeatureFlag.getValue(this.ldClient)
    const accountProfile = this.getAccount()
    if (allowed && Account.isCompanyManager(accountProfile)) {
      return super.deferExec(deferRecords)
    } else {
      return this.notAllowedLoader.bind(this)()
    }
  }
}
